import React, {useEffect, useState} from "react";
import {Container, CircularProgress} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import axios from "axios";
import {getCookie} from "../../components/auth/Helpers";
import {MuiThemeProvider} from "@material-ui/core/styles";
import {datatableTheme} from "assets/css/datatable-theme.js";

const CabinetsByCityReport = () => {
  const token = getCookie("token");
  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const resp = await axios.get(`${process.env.REACT_APP_BASE_URL}/reports/cabinets_cities`, {
          headers: {Authorization: `Bearer ${token}`},
        });

        const data = resp.data; // flat array of rows from new API

        if (!Array.isArray(data)) {
          setIsLoading(false);
          return;
        }

        setRows(data);

        // Extract status columns dynamically (all keys except City / Door Type)
        const statusColumns = Object.keys(data[0] || {}).filter((k) => k !== "City" && k !== "Door Type");

        // Build MUI columns
        const finalColumns = [
          {
            name: "Door Type",
            label: "City / Door Type",
            options: {
              filter: false,
              sort: false,
              customBodyRenderLite: (dataIndex) => {
                const row = data[dataIndex];
                return `${row["City"]} / ${row["Door Type"]}`;
              },
            },
          },
          ...statusColumns.map((status) => ({
            name: status,
            label: status,
            options: {
              filter: false,
              sort: false,
              customBodyRenderLite: (dataIndex) => {
                const row = data[dataIndex];
                return row[status] ?? 0;
              },
            },
          })),
        ];

        setColumns(finalColumns);
        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching report:", err);
        setIsLoading(false);
      }
    };

    fetchReport();
  }, []);

  const options = {
    selectableRows: "none",
    filter: false,
    search: false,
    pagination: true,
    serverSide: false,
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    responsive: "standard",
  };

  return (
    <Container maxWidth="xl" style={{marginTop: 20}}>
      {!isLoading ? (
        <MuiThemeProvider theme={datatableTheme}>
          <MUIDataTable data={rows} columns={columns} options={options} />
        </MuiThemeProvider>
      ) : (
        <div style={{display: "flex", justifyContent: "center", marginTop: 50}}>
          <CircularProgress />
        </div>
      )}
    </Container>
  );
};

export default CabinetsByCityReport;
